"use strict";
var cache_service_1 = require('./src/services/cache.service');
exports.CacheService = cache_service_1.CacheService;
var cache_storage_abstract_service_1 = require('./src/services/storage/cache-storage-abstract.service');
exports.CacheStorageAbstract = cache_storage_abstract_service_1.CacheStorageAbstract;
var cache_local_storage_service_1 = require('./src/services/storage/local-storage/cache-local-storage.service');
exports.CacheLocalStorage = cache_local_storage_service_1.CacheLocalStorage;
var cache_memory_service_1 = require('./src/services/storage/memory/cache-memory.service');
exports.CacheMemoryStorage = cache_memory_service_1.CacheMemoryStorage;
var cache_session_storage_service_1 = require('./src/services/storage/session-storage/cache-session-storage.service');
exports.CacheSessionStorage = cache_session_storage_service_1.CacheSessionStorage;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-cache-service/dist/ng2-cache-service.js
// module id = 2045
// module chunks = 3